"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParams = exports._navParams = void 0;
const react_router_dom_1 = require("react-router-dom");
exports._navParams = { current: {} };
function useParams() {
    const routerParams = (0, react_router_dom_1.useParams)();
    return Object.assign(Object.assign({}, exports._navParams.current), routerParams);
}
exports.useParams = useParams;
exports.default = useParams;
